import { render } from "./DatasourceEDA.vue?vue&type=template&id=67ccf708&scoped=true&ts=true"
import script from "./DatasourceEDA.vue?vue&type=script&lang=ts"
export * from "./DatasourceEDA.vue?vue&type=script&lang=ts"

import "./DatasourceEDA.vue?vue&type=style&index=0&id=67ccf708&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67ccf708"]])

export default __exports__